import React from 'react';
import YogaServices from '../components/yoga/YogaServices';
import ContactForm from '../components/contact/ContactForm';
import SuccessModal from '../components/contact/SuccessModal';
import { useContact } from '../hooks/useContact';
import SEO from '../components/SEO';

const Yoga = ({ siteData }) => {
    const {
        isContactFormOpen,
        isSuccessModalOpen,
        contactData,
        openContactForm,
        closeContactForm,
        handleContactSuccess,
        closeSuccessModal,
    } = useContact();

    return (
        <>
            <SEO
                title="Yoga & Wellness | Savana Ashlea"
                description="Find peace and balance through transformative yoga experiences. Explore yoga classes, workshops, and wellness services designed to nurture your mind, body, and spirit."
                url="https://savanashlea.com/yoga"
                image="/yoga-og.jpg"
            />
            <div className="pt-16 min-h-screen">
                <YogaServices yogaData={siteData?.yoga} onContactClick={openContactForm} />

                {isContactFormOpen && (
                    <ContactForm
                        inquiryType={contactData.inquiryType}
                        prefilledData={contactData.prefilledData}
                        onClose={closeContactForm}
                        onSuccess={handleContactSuccess}
                    />
                )}

                {isSuccessModalOpen && (
                    <SuccessModal onClose={closeSuccessModal} />
                )}
            </div>
        </>
    );
};

export default Yoga;